import * as React from 'react';
import * as styles from './styles.css';
import { ArticleParagraph2, Spinner } from '@cian/ui-kit';
import { ADVERTISING_LABELING_TEXT } from '../../../../constants/advertisingLabeling';

export interface ISearchTextModalListingProps {
  isLoading?: boolean;
  isEmpty: boolean;
  totalCountsText: React.ReactNode;
  listing: React.ReactNode;
  pagination: React.ReactNode;
}

export function SearchTextModalListing({
  isLoading,
  isEmpty,
  totalCountsText,
  listing,
  pagination,
}: ISearchTextModalListingProps) {
  return (
    <div>
      <div className={styles['summary']}>{totalCountsText}</div>
      <div className={styles['listing']}>
        {isLoading && (
          <div className={styles['preloader']}>
            <Spinner size={32} />
          </div>
        )}
        {listing}
        {pagination}
        {!isEmpty && (
          <div className={styles['advertising-labeling']}>
            <ArticleParagraph2 color={'black_60'}>{ADVERTISING_LABELING_TEXT}</ArticleParagraph2>
          </div>
        )}
      </div>
    </div>
  );
}
